var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconCarbonTrees40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1916_19261)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9749 30.2777C12.6234 30.2783 11.0311 30.2834 10.8435 30.2776C8.02682 30.1913 6 26.8108 6 22.799C6 16.7095 8.99017 11.6261 11.8133 10.4339C12.1913 10.2606 12.582 10.1694 12.9758 10.1694L13 10.1699L13.0242 10.1694C13.418 10.1694 13.8087 10.2606 14.1868 10.4341C17.0098 11.6261 20 16.7095 20 22.799C20 26.8108 17.9732 30.1913 15.1565 30.2776C14.9689 30.2834 13.3766 30.2783 13.0251 30.2777H12.9749Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 21.7485V36.3747",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0769 27.8425L10.3379 24.7954",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5341 30.3182C25.1105 30.3189 23.1916 30.3252 22.9654 30.3181C19.571 30.2116 17.1284 26.0398 17.1284 21.0889C17.1284 13.5738 20.732 7.30061 24.1342 5.82924C24.5898 5.61545 25.0605 5.50293 25.5352 5.50293L25.5643 5.50345L25.5935 5.50293C26.0681 5.50293 26.5388 5.61545 26.9945 5.82953C30.3967 7.30061 34.0002 13.5738 34.0002 21.0889C34.0002 26.0398 31.5576 30.2116 28.1632 30.3181C27.937 30.3252 26.0181 30.3189 25.5946 30.3182H25.5341Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8652 17.6094V36.3746",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9414 23.6629L23.23 20.6362",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8651 26.0843L28.5767 23.0576",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1916_19261"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.50293)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconCarbonTrees40);
export default __webpack_public_path__ + "static/media/pictogramBeaconCarbonTrees40.7036274d9d68c708f2a469172ab6bb62.svg";
export { ForwardRef as ReactComponent };